import moment from "moment-timezone";

export const _getNewsCategories = [
    "Trending",
    "Finance",
    "FEMA",
    "IMPORT EXPORT",
    "Capital Market",
    "GST",
    "Direct Tax",
    "AUDIT AND ACCOUNTS",
    "Other Laws",
    "AI and Technology"
];

export const _getIndianStates = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
    "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
    "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
    "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
    "Uttar Pradesh", "Uttarakhand", "West Bengal",
    "Andaman and Nicobar Islands", "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi NCR", "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry"
];

export const _getDepartmentsList = [
    'Audit', 'Taxation', 'Accounting', 'Finance', 'Compliance',
    'Management', 'Banking', 'Government', 'Education',
    'ERP', 'Startup', 'International'
];

export const _getReligionOptions = [
    "Hindu",
    "Muslim",
    "Christian",
    "Sikh",
    "Buddhist",
    "Jain",
    "Parsi",
    "Jewish",
    "Other"
];

export const _getMaritalStatusOptions = [
    "Never Married", "Divorced", "Widowed"
];

export const _getManglikStatusOptions = [
    "Manglik", "Non-Manglik"
];

export function _getExpiryDateFromRange(range) {
    const today = moment();

    if (range === '1-7') {
        return today.add(7, 'days').format('YYYY-MM-DD');
    } else if (range === '8-15') {
        return today.add(15, 'days').format('YYYY-MM-DD');
    } else if (range === '16+') {
        return today.add(30, 'days').format('YYYY-MM-DD'); // assuming 30 days for 16+
    }
    return null;
}

export const _getWorkTypes = ['Onsite', 'Hybrid', 'WFH'];

export function _generateUniqueCustomId() {
    let str = 'abcdeABCDEFGHIJKfghijklmnopqrstuvwxyzLMNOPQRSTUVWXYZ0123456789';
    let char = '',
        genID = '';

    while(genID.length < 8) {
        char = new Date().getSeconds()+str.charAt(Math.floor(Math.random() * str.length));
        genID += char;
    }
    return genID;
}


export function _formatTimeMMSS(seconds) {
    const minutes = Math.floor(seconds / 60); // Get minutes
    const remainingSeconds = seconds % 60; // Get remaining seconds

    // Return formatted time as an array [minuteTens, minuteOnes, ":", secondTens, secondOnes]
    return [
        String(Math.floor(minutes / 10)),    // Tens place of minutes
        String(minutes % 10),                // Ones place of minutes
        ":",                                 // Separator
        String(Math.floor(remainingSeconds / 10)), // Tens place of seconds
        String(remainingSeconds % 10)         // Ones place of seconds
    ];
}
